<script lang="ts">
    import {link,push} from 'svelte-spa-router'
    import * as qs from 'qs';
    import * as numeral from 'numeral';
    import Header from './Header.svelte';
    import HeaderThemes from './HeaderThemes.svelte';
    import Footer from './Footer.svelte';
    import FooterThemes from './Footerthemes.svelte';
    import Clipboard from "svelte-clipboard";
    import Fa from 'svelte-fa'
    import { faLine } from '@fortawesome/free-brands-svg-icons';
    import { faSpinner,faCopy,faDownload,faCheckCircle, faCommentsDollar,faClose,faCloudDownload } from '@fortawesome/free-solid-svg-icons';
    import Swal from 'sweetalert2'
    import Time from "svelte-time";
    

    document.body.scrollIntoView();
    let dataSetting = JSON.parse(window.localStorage.getItem('setting'))

    export let params: any = {};

    let loading = true




    async function getMember() {
        const res = await fetch(window.localStorage.getItem("apiurl")+"member/gotosetzero", {
            method: 'POST',
            headers:{
                'Content-Type': 'application/x-www-form-urlencoded',
                'Authorization': 'Bearer '+window.localStorage.getItem('access_token'),
                'x-api-appid': window.localStorage.getItem("appid")
            },
            body: qs.stringify({bankid: params.bankid || ''})
        })
        const json = await res.json()
        if (json.statusCode==200) {
            
            window.location = json.payload.url
		}
        loading = false
    }


    let promise
    $: {
        if (params && params.bankid) {
            getMember()
        }
    }

    
    let textarea;
	async function copyNumber(){
		textarea.select();
		document.execCommand('copy');
	}
    // getMember()

</script>
<div class="default-home">
<div class="row pt-2 mb-5" style="background-image: url('{dataSetting.background}'); background-size:cover; background-repeat: no-repeat; background-position: center top;">
    <Header />
    <div class="col-12 text-center mt-3"><h4 style=" background: linear-gradient(135deg, rgb(0 0 0) 0%, rgb(86 80 80) 50%, rgb(131 120 120) 51%, rgb(54 50 50) 71%, rgb(0 0 0) 100%);
        box-shadow: 5px 5px 10px #000 !important;
        line-height: 30px;
        border-radius: 5px;
        padding: 2px 7px;color:gold;">ฝากเงิน</h4></div>
    <div class="col-12 pb-5" style="min-height: 500px;">
        <div class="card mt-3 bg-black">
            <div class="card-body text-center py-5">
                <Fa icon={faSpinner} size="3x" pulse class="text-white"/>
                <h5 class="text-white mt-4">รอสักครู่</h5>
                <p class="text-warning mb-0">เรากำลังไปยังหน้าฝากเงิน</p>
            </div>
        </div>
    </div>
</div>
<Footer />
</div>
<div class="themes-home" style="display: none;">
    <div class="row mb-3 blog-deposits">
        <HeaderThemes/>
        <div class="col-12 pb-5" style="min-height: 500px;">
            <div class="card mt-3 bg-black">
                <div class="card-body text-center py-5">
                    <Fa icon={faSpinner} size="3x" pulse class="text-white"/>
                    <h5 class="text-white mt-4">รอสักครู่</h5>
                    <p class="text-warning mb-0">เรากำลังไปยังหน้าฝากเงิน</p>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="themes-home-section" style="display: none;display:flex;">
</div>
<div class="footer-themes" style="display: none;">
    <FooterThemes />
</div>
<style>
    .bg-black{
        background: #000000ad !important;
    }
</style>
